<template>
  <div class="home-wrap">
    <div class="home-container clearfix">
      <section class="home-side-l">
        <div class="map-nav-wrap">
          <div class="title-wrap clearfix">
            <div class="title-name-box pull-left">
              <span class="icon-logo pull-left">
                <img src="../../public/images/square.png" alt="">
              </span>
              <p class="pull-left title-name-text">申请实习入口导航</p>
            </div>
            <div class="title-warn pull-right">
              <span>点击地图进行选择</span>
            </div>
          </div>
          <div class="map-nav-bd">
           <map-nav></map-nav>
          </div>
        </div>
        <div class="home-news-wrap">
          <div class="title-wrap clearfix">
            <div class="title-name-box pull-left">
              <span class="icon-logo pull-left">
                <img src="../../public/images/square.png" alt="">
              </span>
              <p class="pull-left title-name-text">公告公示</p>
              <span class="pull-left icon-horn-box">
                <i class="iconfont icon-xiaolaba"></i>
              </span>
            </div>
            <router-link class="more pull-right" to="#">
              <span>更多&gt;&gt;</span>
            </router-link>
          </div>
          <div class="home-news-bd">
            <ul class="news-box">
              <li class="news-item" v-for="(item,index) in newsDataArr" :key="index">
                <a class="clearfix" :href="item.newsUrl">
                  <p class="pull-left news-text">{{ item.newsText }}</p>
                  <span class="pull-right">{{ item.newsTime }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section class="home-side-r">
        <div class="home-search-section">
          <div class="home-search-wrap">
            <div class="search-title">
              <span>申请实习进度查询</span>
            </div>
            <div class="search-box">
              <input class="search-input" type="text" placeholder="请输入申请实习编号/身份证号码">
              <div class="btn-search search-color-jd" @click="getNext('#/internship')">
                <i class="iconfont icon-sousuo"></i>
              </div>
            </div>
          </div>
          <div class="home-search-wrap mt-search">
            <div class="search-title">
              <span>实习人员信息查询</span>
            </div>
            <div class="search-box">
              <input class="search-input" type="text" placeholder="请输入姓名/实习证号/律所">
              <div class="btn-search search-color-xx" @click="getNext('#/internship-information')">
                <i class="iconfont icon-sousuo"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="home-system-wrap">
          <div class="system-title">
            <a class="more-link" href="#">
              <img src="../../public/images/bg2.png" alt="">
            </a>
          </div>
          <div class="system-bd">
            <ul class="system-box">
              <li class="system-item" v-for="(item,index) in systemDataArr" :key="index">
                <a class="clearfix" :href="item.url">
                  <span class="pull-left icon-box">
                    <i class="iconfont icon-wenjian"></i>
                  </span>
                  <span class="pull-right systemtext">{{ item.systemText }}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
    <div class="home-link-wrap">
      <div class="link-wrap">
      <ul class="wrapper">
        <li class="list">
          <a href="javascript:;">友情链接:</a>
        </li>
        <li class="list" v-for="(item, index) in linkArr" :key="index">
          <a href="javascript:;">{{item.name}}</a>
        </li>
      </ul>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import mapNav from "../components/map-nav.vue";
// import getpk from '../encrypt/getPassKey' // 获取密码加密函数
// console.log(getpk)
// import api from "../api/index";
export default {
  components: {
    mapNav
  },
  name: "home",
  data() {
    return {
      newsDataArr: [
        {
          newsText: "·中华人民共和国律师法的详细解读会议",
          newsTime: "18-11-13",
          newsUrl: "#"
        },
        {
          newsText:
            "·中华全国律师协会建筑工程与房地产专业委员会关于公开征集农村土地入市引发的相业委员会关于公开征集农村土地",
          newsTime: "18-11-13",
          newsUrl: "#"
        },
        {
          newsText:
            "·中华全国律师协会建筑工程与房地产专业委员会关于公开征集农村土地入市引发的相业委员会关于公开征集农村土地",
          newsTime: "18-11-13",
          newsUrl: "#"
        }
      ],
      systemDataArr: [
        {
          systemText: "《中华人民共和国律师法》",
          url: "#"
        },
        {
          systemText: "中华全国律师协会《申请律师执业人 员实习管理规则》",
          url: "#"
        },
        {
          systemText: "《中华人民共和国律师法》",
          url: "#"
        },
        {
          systemText: "中华全国律师协会《申请律师执业人 员实习管理规则》",
          url: "#"
        },
        {
          systemText: "中华全国律师协会《申请律师执业人 员实习管理规则》",
          url: "#"
        }
      ],
       linkArr: [
        { name: '中国律师网', url: 'javacript:;' },
        { name: '中国法律服务网', url: 'javacript:;' },
        { name: '中国普法网', url: 'javacript:;' },
        { name: '中国律师培训网', url: 'javacript:;' },
        { name: '中华人民共和国司法部', url: 'javacript:;' }
      ]
    };
  },
  methods: {
    ...mapActions([]),
    getNext (url) {
      window.location.href = url
    }
  },
  watch: {
    allNumber(newVal) {
      console.log(newVal);
    }
  },
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss">
@import "../assets/scss/variables";
@import "../assets/scss/mixins";
@import "../assets/scss/common";
.home-wrap {
  width: 100%;
  height: auto;
  background-color: $white;
  .home-link-wrap {
    margin-top: 80px;
    width: 100%;
    height: auto;
    background-color: #f8f8f8;
  }
   .link-wrap .wrapper {
    width: 768px;
    height: 100px;
    line-height: 100px;
    display: flex;
    justify-content: space-between;
    
    a {
      color: #4b8dfd;
    }
    a:hover {
      border-bottom: 1px solid #4b8dfd;
    }
  }
}
.footer-wrap {
  margin-top: 0;
}
.home-container {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  padding-top: 80px;
}
.home-side-l {
  float: left;
  width: 810px;
  height: auto;
}
.map-nav-wrap {
  width: 100%;
  height: 700px;
  border: 1px solid $home-border;
  .title-wrap {
    width: 100%;
    height: auto;
    padding: 0 30px 0 24px;
    background-color: $home-title;

    .title-warn {
      width: auto;
      height: 50px;
      line-height: 50px;
      font-size: $font-size-lg;
      color: $home-gray-light;
    }
  }
  .title-name-box {
    height: 100%;
    .icon-logo {
      margin-right: 20px;
      width: 18px;
      height: 100%;
      line-height: 50px;
    }
    .title-name-text {
      padding: 0;
      margin: 0;
      line-height: 50px;
      font-size: 20px;
      color: $gray-dark;
      font-weight: 700;
    }
  }
  .map-nav-bd {
    width: 100%;
    height: calc(100% - 50px);
  }
}
.home-news-wrap {
  margin-top: 30px;
  width: 100%;
  height: auto;
  border: 1px solid $home-border;
  .title-wrap {
    width: 100%;
    height: auto;
    padding: 0 20px 0 24px;
    background-color: $home-title;

    .more {
      width: auto;
      height: 50px;
      line-height: 50px;
      font-size: $font-size-lg;
      color: $home-gray-light;
      cursor: pointer;
      &:hover {
        color: $a-hover;
      }
    }
  }
  .title-name-box {
    width: auto;
    height: 100%;
    .icon-logo {
      margin-right: 20px;
      width: 18px;
      height: 100%;
      line-height: 50px;
    }
    .icon-horn-box {
      margin-left: 24px;
      height: 50px;
      line-height: 50px;
      .iconfont {
        font-size: 18px;
        color: #e86b6b;
      }
    }
    .title-name-text {
      padding: 0;
      margin: 0;
      line-height: 50px;
      font-size: 20px;
      color: $gray-dark;
      font-weight: 700;
    }
  }
  .home-news-bd {
    width: 100%;
    height: auto;
  }
  .news-box {
    width: 100%;
    height: auto;
    padding: 15px 20px 15px 24px;
    .news-item {
      line-height: 40px;
      font-size: $font-size-lg;
    }
    .news-text {
      width: 640px;
      text-align: left;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
}
.home-side-r {
  float: right;
  width: 360px;
  height: auto;
}
.home-search-section {
  width: 100%;
  height: auto;
  .home-search-wrap {
    width: 100%;
    height: auto;
    .search-color-jd {
      background-color: #2883cd;
    }
    .search-color-xx {
      background-color: #f3a72f;
    }
  }
  .mt-search {
    margin-top: 40px;
  }
  .search-title {
    width: 100%;
    padding-bottom: 15px;
    text-align: center;
    font-size: 22px;
    font-weight: 700;
    color: $search-title-color;
  }
  .search-box {
    position: relative;
    width: 100%;
    height: 60px;

    .search-input {
      position: absolute;
      padding: 16px;
      top: 0;
      left: 0;
      width: calc(100% - 80px);
      height: 100%;
      font-size: $font-size-lg;
      color: $gray-base;
      border: 1px solid $home-border;
      border-right: none;
      outline: none;
    }
    .btn-search {
      position: absolute;
      top: 0;
      bottom: 0;
      right: 0;
      width: 80px;
      text-align: center;
      line-height: 60px;
      cursor: pointer;
      .iconfont {
        font-size: 23px;
        color: $white;
      }
    }
  }
}

.home-system-wrap {
  margin-top: 42px;
  width: 100%;
  height: 400px;
  border: 1px solid $home-border;
  .system-title {
    width: 100%;
    height: auto;
  }
  .more-link {
    width: 100%;
    height: auto;
    display: block;
  }
  .system-bd {
    width: 100%;
    height: auto;
  }
  .system-box {
    width: 100%;
    height: auto;
    padding: 20px 0 10px;
    .system-item {
      padding: 8px 30px;
      text-align: left;
      font-size: $font-size-lg;
    }
    .iconfont {
      line-height: 1;
      font-size: 20px;
    }
    .systemtext {
      width: 260px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }
  }
}
</style>